<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm6 offset-sm3>
        <v-layout align-center justify-center column pb-2>
          <h2 class="heading-3">Register with email</h2>
        </v-layout>

        <v-alert  :value="true"  v-if="error != null" type="error" >{{ error.message }}</v-alert>

        <v-layout justify-center column>

          <v-form ref="form" v-model="valid" @submit="signUp">
            <v-layout row>
              <v-flex xs12 pb-0>
                <v-text-field outline v-model="firstName" :rules="firstNameRules" label="First Name *" required ></v-text-field>
              </v-flex>

              <v-flex xs12 pb-0>
                <v-text-field outline v-model="lastName" :rules="lastNameRules" label="Last Name *"  required ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 pb-0>
                <v-text-field outline v-model="username" :rules="usernameRules" type="email" label="Email Address *" required ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 pb-0>
                <v-text-field outline v-model="postcode" :rules="postcodeRules" label="Postcode *" required ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row>
                <v-flex xs12 sm3>Date of Birth</v-flex>
                <v-flex xs12 sm3>
                  <v-select
                    :items="days"
                    label="DD"
                    v-model="dobDay"
                    :rules="dobRules"
                    required
                    outline
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm3 >
                  <v-select
                    :items="months"
                    label="MM"
                    v-model="dobMonth"
                     :rules="dobRules"
                    outline
                    required
                  ></v-select>
                  </v-flex>
                <v-flex xs12 sm3>
                  <v-select
                    :items="years"
                    label="YYYY"
                    v-model="dobYear"
                     :rules="dobRules"
                    outline
                    required
                  ></v-select>
                </v-flex>
              </v-layout>

            <v-layout row>
              <v-flex xs12 pb-0>
                <v-text-field outline ref="pass" v-model="pass" :rules="passRules" label="Password *" type="password" required ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-text-field outline ref="passConfirm" v-model="passConfirm" :rules="passConfirmRules" label="Confirm Password *"  type="password"  required></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 pb-0>
                <p class="password-notice">Your Password must be 8-12 characters in length, contain at least 1 special character, 1 capital letter, 1 lower case letter and 1 number.</p>
              </v-flex>
            </v-layout>
            <!-- Left In - Will use v-chip in the future to get rid of Radio Buttons -->
            <!-- <v-chip
              class="mr-2"
              @click="partnerEmail = `Yes`" >
                Yes
            </v-chip>
            
            <v-chip
              class="mr-2"
              @click="partnerEmail = `No`" >
                No
            </v-chip> -->

            <v-layout row>
              <v-flex xs12 pb-0>
                <v-radio-group
                  v-model="clubEmail"
                  color="#005ca6" 
                  row 
                  :rules="radioRules"
                  required >
                  <span slot="label">
                    <h3 class="label-heading">
                      <span>
                        <img class="required-star" src="../assets/Asterisk-1@2x.png" />
                      </span>
                      Opt-in to Wigan Athletic Football Club
                    </h3>
                    <p class="custom-label">I would like to be kept updated by Wigan Athletic Football Club on the latest Club news, ticketing information, retail offers and competitions.
                    </p>
                  </span>
                
                  <v-radio
                  label="Yes"
                  :value="`true`" >
                  </v-radio>

                  <v-radio
                    label="No"
                    :value="`false`" >
                  </v-radio>
                
                </v-radio-group>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 py-0>
                
                <v-radio-group
                  v-model="partnerEmail"
                  color="#005ca6"
                  row
                  :rules="radioRules"
                  required 
                  class="radios">
                  <span slot="label">
                    <h3 class="label-heading">
                      <span>
                        <img class="required-star" src="../assets/Asterisk-1@2x.png" />
                      </span>
                      Opt-in to Wigan Athletic Football Club Partners
                    </h3>
                    <p class="custom-label">I would like to be kept updated via email on the latest information and offers from Club partners.&nbsp;&nbsp;<a href="https://wiganathletic.com/commercial-partners/" target="_blank">Our Club Partners</a>
                    </p>
                  </span>

                  <v-radio
                    label="Yes"
                    :value="`true`" >
                  </v-radio>

                  <v-radio
                    label="No"
                    :value="`false`" >
                  </v-radio>
                
                </v-radio-group>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 py-0>
                
                <v-radio-group
                  v-model="stadiumNews"
                  color="#005ca6"
                  row
                  :rules="radioRules"
                  required 
                  class="radios">
                  <span slot="label">
                    <h3 class="label-heading">
                      <span>
                        <img class="required-star" src="../assets/Asterisk-1@2x.png" />
                      </span>
                      Opt-in to Wigan Athletic Football Club Stadium
                    </h3>
                    <p class="custom-label">I would like to be kept updated via email on the latest stadium news and events.
                    </p>
                  </span>

                  <v-radio
                    label="Yes"
                    :value="`true`" >
                  </v-radio>

                  <v-radio
                    label="No"
                    :value="`false`" >
                  </v-radio>
                
                </v-radio-group>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 py-0>

                <v-radio-group
                  v-model="termsAgree"
                  color="#005ca6"
                  row
                  :rules="termsAgreeRules"
                  required 
                  class="radios">
                  <span slot="label">
                  <h3 class="label-heading">
                    <span>
                      <img class="required-star" src="../assets/Asterisk-1@2x.png" />
                    </span>
                    I have read and understood the Club's privacy policy
                  </h3>
                  <p class="custom-label">You can access our preference centre at any time to opt out of communications and control how we use your data.&nbsp;&nbsp;<a href="https://wiganathletic.com/info/privacy-policy/" target="_blank">Privacy Policy</a>
                  </p>
                  </span>

                  <v-radio
                    label="Yes"
                    :value="true" >
                  </v-radio>
                
                </v-radio-group>

              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12>
                <p class="notice">Please note that if you opt not to receive communication from Wigan Athletic Football Club that you will not receive information and offers tailored to you, including ticketing information and reminders. You will still receive transactional emails when purchasing from us. You can access our preference centre at any time to opt-out of communications and control how we use your data.</p>
              </v-flex>
            </v-layout>

            <v-layout row align-center mx-1 py-0>
              <router-link to="/" class="text-button">Already registered?</router-link>
              <v-spacer />
              <button type="submit" class="button" :disabled="!valid">Register</button>
            </v-layout>

          </v-form>
        </v-layout>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'Registration',
  data () {
    
    return {
      valid: true,
      firstNameRules: [
        v => !!v || 'First name is required'
      ],
      lastNameRules: [
        v => !!v || 'Last name is required'
      ],
      passRules: [
        v => !!v || 'Password is required',
        v => (v && v.length >= 8) || 'Password must be at least 8 characters',
        v => /.*[a-z].*/.test(v) || 'Password must contain at least one lower case letter',
        v => /.*[A-Z].*/.test(v) || 'Password must contain at least one upper case letter',
        v => /\d/.test(v) || 'Password must contain at least one number',
        v => /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(v) || 'Password must contain at least one special character (e.g. ^ $ * . ! @ # % &)',
        v => (this.passConfirm.length >=8 && v == this.passConfirm) || 'Password confirmation must match password'
      ],
      dobRules: [
        v => !!v || 'Date of Birth is required'
      ],
      passConfirmRules: [
        v => (v == this.pass) || 'Password confirmation must match password'
      ],
      postcodeRules: [
        v => !!v || 'Postcode is required'
      ],
      usernameRules: [
        v => !!v || 'Email address is required',
        v => /.+@.+/.test(v) || 'Email must be valid'
      ],
      termsAgreeRules: [
        v => !!v || 'You must agree to continue'
      ],
      radioRules: [
        v => !!v || 'You must select your communication preferences to continue' 
      ],
      firstName: '',
      lastName: '',
      username: '',
      postcode: '',
      dobDay: null,
      dobMonth: null,
      dobYear: null,
      pass: '',
      clubEmail: null,
      partnerEmail: null, 
      stadiumNews: null,
      termsAgree: false,
      passConfirm: '',
      error: null,
      loading: false,
      days: [],
      months: [],
      years: []
    }
  },
  mounted (){
    this.populateDates ()
  },
  watch: {
    pass: function (val, oldVal) {
      this.$refs.form.validate()
    },
    passConfirm: function (val, oldVal) {
      this.$refs.form.validate()
    }
  },
  methods: {
    pad (num, size) {
      var s = num+"";
      while (s.length < size) s = "0" + s;
      return s;
    },
    populateDates () {
      console.log('ADDING DATES')
      for(var d=1; d<32; d++){
        this.days.push(d)
      }
      for(var m=1; m<13; m++){
        this.months.push(m)
      }
      var thisYear = new Date().getFullYear()
      for(var y=thisYear+1; y > 1900 ; y--) {
        this.years.push(y)
      }
    },
    signUp (e) {
        e.preventDefault()
        this.loading = true
        var email = this.username
        var password = this.pass
        var firstName = this.firstName
        var lastName = this.lastName
        var address = {
          "postcode": this.postcode
        }
        var clubEmail = this.clubEmail.toString();
        var partnerEmail = this.partnerEmail.toString();
        var stadiumNews = this.stadiumNews.toString();
        var termsAgree = this.termsAgree.toString();
        
        var attributesList = {
            "given_name": firstName, 
            "family_name": lastName, 
            "address": JSON.stringify(address),
            "custom:club_email": clubEmail, 
            "custom:partner_email": partnerEmail,
            "custom:stadium_news": stadiumNews,
            "custom:privacy_accepted": termsAgree
        }
        if(this.dobDay && this.dobMonth && this.dobYear){
          attributesList['birthdate'] = this.dobYear + '-' + this.pad(this.dobMonth, 2) + '-' + this.pad(this.dobDay, 2)
        }
       
        this.$signUp(email, password, attributesList).subscribe((data) => {
            console.log("sign up successful"+data)
            this.$router.push("/confirm");
        }, 
        (err)=> {
            //if we get an UnkownError it is more than likely because the user has a status of 'FORCE_CHANGE_PASSWORD' in AWS Cognito
            console.log(err.message)
            this.error = err
        });

    },
  }
}
</script>

<style>
  .password-notice {
    margin: 0 0 20px;
    padding: 0 0 40px;
    color: #878787;
    font-size: 15px;
    line-height: 22px;
    border-bottom: 1px solid #eee;
  }

  .required-star {
    height: 8px;
    display: inline-block;
    margin: 0 4px 4px 0;
  }

  .label-heading {
    padding-bottom: 8px;
  }

  .v-input--switch__track.theme--light.error--text {
    color: rgba(0,0,0,0.38) !important;
  }
  .v-input--selection-controls__ripple.error--text{
    color: #fff !important;
  }
  .v-input--switch__thumb.theme--light.error--text{
    color:#fafafa !important;
  }
  .v-input--radio-group--row .v-input--radio-group__input {
    flex-wrap: nowrap !important;
  }
  .v-input--radio-group__input {
    align-items: flex-start;
  }
  .custom-label {
    margin-right: 40px;
  }
  .v-input__control {
    width: 100% !important;
  }
  .v-label {
    width: 100% !important;
  }

</style>